<mf-page title="Incidentes">
  <mf-row>
    <mf-issue-grid
      #grid
      [showCreateButton]="true"
      [rowSelection]="true"
      (selectedItems)="onSelectedItems($event)" />
  </mf-row>
  <mf-row>
    <mf-button-secondary
      text="Marcar como resueltas"
      [disabled]="!selectedItems() || selectedItems().length === 0"
      (click)="resolve()" />
  </mf-row>
</mf-page>
